import Lightbox from '@/js/components/lightbox/lightbox';

// eslint-disable-next-line no-new
new Lightbox(
  '[data-lightbox]',
  document.getElementById('btn-gallery'),
  0,
);
